export const NewProjectMutations = {
  SetNewProjectSuccess: 'setNewProjectSuccess',
  SetIsCreatingProject: 'setIsCreatingProject'
};

export const NewProjectActions = {
  CreateProject: 'createProject',
  SetNewProject: 'setNewProject'
};

export const NewProjectGetters = {
  NewProject: 'NewProject',
  IsCreatingProject: 'IsCreatingProject'
};
